import { IRootState } from '../reducer'
import { prefix } from './actions'

export const notification = (state: IRootState) => state[prefix].notification

export const messageToasts = (state: IRootState) => state[prefix].messageToasts

export const title = (state: IRootState) => state[prefix].title

export const titleCasing = (state: IRootState) => state[prefix].titleCasing

export const pageSubtitle = (state: IRootState) => state[prefix].pageSubtitle

export const pageParent = (state: IRootState) => state[prefix].pageParent

export const pageLogo = (state: IRootState) => state[prefix].pageLogo

export const pageLogoSubject = (state: IRootState) => state[prefix].pageLogoSubject
